
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insight/[insightId]",
      function () {
        return require("private-next-pages/insight/[insightId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insight/[insightId]"])
      });
    }
  